import { get } from "."

export const getTransactionReportReq = ({from, until}) => {
    return new Promise((resolve, rej) => {
        get(`api/statistic/transaction-report?from=${from}&until=${until}`)
        .then(res => resolve(res.data))
        .catch(e => {rej(e.response.data.message)}) 
    }) 
  }